import React, {Component} from 'react';
import Util from '../../../utils/utils';
import $ from 'jquery';
import * as config from "../../../config";
import axios from "axios";
import ButtonLoader from "../../../components/form/Button/Button";
import ToastMessage from "../../../components/layout/toast/toast";

export default class LoginForm extends Component {

    async loginUser(phone_number) {
        let bodyFormData = new FormData();

        bodyFormData.append('phone_number', phone_number);

        return await axios.post(config.api_url + "/account/login", bodyFormData, {
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    }

    async emailLoginUser(email) {
        let bodyFormData = new FormData();

        bodyFormData.append('email', email);

        return await axios.post(config.api_url + "/account/login", bodyFormData, {
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    }

    async verifyUser(phone_number, verify) {
        let bodyFormData = new FormData();

        bodyFormData.append('phone_number', phone_number);
        bodyFormData.append('verify_code', verify);

        return await axios.post(config.api_url + "/account/verify", bodyFormData, {
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    }

    constructor(props) {
        super(props);
        this.state = {
            phoneNumber: "",
            email: "",
            loading: false,
            digits: "",
            toastShow: false,
            toastMessage: "",
            prefix: "+۹۸"
        };
    }

    componentDidUpdate() {
        $("#phoneNumber").on('input', function () {
            let val = $(this).val();
            $(this).val(Util.convertNumber(val, "fa"));
        });

        $("#prefix").on('input', function () {
            let val = $(this).val();
            $(this).val(Util.convertNumber(val, "fa"));
        });

        $('.verify').find('input').each(function () {
            let obj = $(this);
            obj.attr('maxlength', 4);
            obj.on("input", function () {
                obj.val(Util.convertNumber(obj.val(), "fa"));
            });

            $(this).on('keyup', function (e) {
                let parent = $($(this).parent());
                if (e.keyCode === 8 || e.keyCode === 37) {
                    let prev = parent.find('input#' + $(this).data('previous'));
                    if (prev.length) {
                        $(prev).select();
                    }
                } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39 || e.keyCode === 229) {
                    let next = parent.find('input#' + $(this).data('next'));
                    if ($(this).val() !== "") {
                        if (next.length) {
                            $(next).select();
                        } else {
                            if (parent.data('autosubmit')) {
                                parent.submit();
                            }
                        }
                    }
                }
            });

        });

    }

    hideToast = () => {
        this.setState({toastShow: false});
    };

    redirectToEmailLogin = () => {
        Util.setSession("state", 2);
        this.props.redirectSetState({"redirect": true, "url": "/email-login"});
    };

    redirectToLogin = () => {
        Util.setSession("state", null);
        this.props.redirectSetState({"redirect": true, "url": "/login"});
    };

    loginForm = () => {
        const handleSubmit = async () => {
            if (this.state.phoneNumber) {
                let phoneNumber = Util.convertNumber(this.state.prefix, "en") + Util.convertNumber(this.state.phoneNumber, "en");

                let response = await this.loginUser(phoneNumber);

                if (response.data.status) {
                    Util.setSession("phoneNumber", phoneNumber);
                    Util.setSession("state", 1);
                    Util.setSession("loginType", response.data.login_type);
                    this.props.redirectSetState({"redirect": true, "url": "/verify"});
                } else {
                    let error = response.data.error.join("\n");
                    this.setState({toastShow: true, toastMessage: error});
                }
            }
        };

        this.componentDidUpdate();

        return (
            <div className="col-12 m-0 p-0">
                <div className="row login-card mb-5">
                    <p className="login-title">
                        ورود | عضویت
                    </p>
                    <form className="row login-form">
                        <label className="login-form-label" htmlFor="phoneNumber">
                            برای ورود و یا عضویت شماره موبایل را وارد کنید
                        </label>
                        <div className="d-flex justify-content-center">
                            <div className="first-input">
                                <input
                                    value={this.state.prefix}
                                    tabIndex="1"
                                    name="prefix"
                                    id="prefix"
                                    type="tel"
                                    minLength="2"
                                    maxLength="3"
                                    onInput={e => this.setState({prefix: e.target.value})}/>
                            </div>
                            <input
                                tabIndex="2"
                                className="login-form-input"
                                minLength="10"
                                maxLength="10"
                                type="tel"
                                id="phoneNumber"
                                name="phoneNumber"
                                placeholder="۱۲۳۴۵۶۷۸۹"
                                onInput={e => this.setState({phoneNumber: e.target.value})}/>
                        </div>
                        <span className="small text-danger text-center w-100 mb-2 mt-0">ابتدا پیش شماره را وارد و سپس شماره همراه خود را بدون صفر وارد کنید</span>
                        <ButtonLoader
                            tabIndex="3"
                            loadingTxt="درحال دریافت اطلاعات"
                            normalTxt="دریافت کد"
                            handleData={handleSubmit}
                        />
                        <button type="button" className={'submit'} onClick={this.redirectToEmailLogin}>
                            ورود با ایمیل
                        </button>

                    </form>
                </div>
            </div>
        );
    };

    emailLoginForm = () => {
        const handleSubmit = async () => {
            if (this.state.email) {
                let email = this.state.email;

                let response = await this.emailLoginUser(email);

                if (response.data.status) {
                    Util.setSession("email", email);
                    Util.setSession("phoneNumber", response.data.phone_number);
                    Util.setSession("state", 1);
                    Util.setSession("loginType", response.data.login_type);
                    this.props.redirectSetState({"redirect": true, "url": "/verify"});
                } else {
                    let error = response.data.error.join("\n");
                    this.setState({toastShow: true, toastMessage: error});
                }
            }
        };

        this.componentDidUpdate();

        return (
            <div className="col-12 m-0 p-0">
                <div className="row login-card mb-5">
                    <p className="login-title">
                        ورود | عضویت
                    </p>
                    <form className="row login-form">
                        <label className="login-form-label" htmlFor="email">
                            برای ورود و یا عضویت ایمیل را وارد کنید
                        </label>
                        <input
                            tabIndex="1"
                            className="login-form-input email"
                            type="email"
                            id="email"
                            name="email"
                            placeholder="لطفا ایمیل خود را وارد کنید"
                            onInput={e => this.setState({email: e.target.value})}/>
                        <ButtonLoader
                            tabIndex="2"
                            loadingTxt="درحال دریافت اطلاعات"
                            normalTxt="دریافت کد"
                            handleData={handleSubmit}
                        />
                        <button type="button" className={'submit'} onClick={this.redirectToLogin}>
                            ورود با موبایل
                        </button>
                    </form>
                </div>
            </div>
        );
    };

    verifyForm = () => {
        const handleSubmit = async (e) => {
            e.preventDefault()
            if (this.state.digits) {
                let digits = Util.convertNumber(this.state.digits, "en");
                let phoneNumber = Util.getSession("phoneNumber");

                let response = await this.verifyUser(phoneNumber, digits);
                if (response.data.status) {
                    Util.setSession("isLogin", true);
                    Util.setSession("token", response.data.token)
                    Util.setSession("state", null);
                    this.props.redirectSetState({"redirect": true, "url": "/"});
                } else {
                    let error = response.data.error.join("\n");
                    this.setState({toastShow: true, toastMessage: error});
                }
            }
        };

        this.componentDidUpdate();

        return (
            <div className="col-12 m-0 p-0">
                <div className="row login-card mb-5">
                    <p className="login-title">
                        ورود | عضویت
                    </p>
                    <form className="row verify" onSubmit={handleSubmit}>
                        <label className="login-form-label" htmlFor="verifyCode">
                            کد تایید برای {Util.getSession("loginType") === "email" ? "ایمیل شما" : "شماره همراه شما"} ارسال شد
                        </label>
                        <div className="verify d-flex justify-content-center">
                            <input min="0" max="9" maxLength="4" id="digit-1" name="digit-1"
                                   value={this.state.digits}
                                   onInput={e => this.setState(state => {
                                       state.digits = e.target.value
                                   })}/>
                            {/*<input min="0" max="9" id="digit-2" name="digit-2" data-next="digit-3" data-previous="digit-1" onInput={e => this.setState( state => state.digits[1] = e.target.value )}/>*/}
                            {/*<input min="0" max="9" id="digit-3" name="digit-3" data-next="digit-4" data-previous="digit-2" onInput={e => this.setState( state => state.digits[2] = e.target.value )}/>*/}
                            {/*<input min="0" max="9" id="digit-4" name="digit-4" data-next="submit" data-previous="digit-3" onInput={e => this.setState( state => state.digits[3] = e.target.value )}/>*/}
                            {/*<input min="0" max="9" id="digit-5" name="digit-5" data-next="digit-6" data-previous="digit-4" onInput={e => this.setState( state => state.digits[4] = e.target.value )}/>*/}
                            {/*<input className="mr-auto" min="0" max="9" id="digit-6" name="digit-6" data-next="submit" data-previous="digit-5" onInput={e => this.setState( state => state.digits[5] = e.target.value )}/>*/}
                        </div>
                        <button className="submit m-0" name="submit" type="submit">تایید</button>
                        <button type="button" className="submit m-0" onClick={this.redirectToLogin}>بازگشت به ورود
                        </button>
                    </form>
                </div>
            </div>
        );
    };

    render() {
        let state = Util.getSession("state");
        let form;
        switch (state) {
            case null:
                form = this.loginForm();
                break;
            case 1:
                form = this.verifyForm();
                break;
            case 2:
                form = this.emailLoginForm();
                break;
            default:
                form = this.loginForm();
                break;
        }

        return (
            <div className="container">
                <div className="row justify-content-center">
                    {form}
                </div>
                <ToastMessage
                    show={this.state.toastShow}
                    message={this.state.toastMessage}
                    hideToast={this.hideToast}
                />
            </div>
        );
    }
}
